/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { colorClassNames } from '../../styles/Colors';

interface Props {
  color: string;
}

const DEFAULT_COLOR = 'gsDarkest';

const IconCloseSmall = (props: Props) => {
  const color = props.color || DEFAULT_COLOR;
  const className = colorClassNames.fill(color);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px">
      <g>
        <path className={className} d="M9.06,8l4.47-4.47a.75.75,0,0,0,0-1.06.75.75,0,0,0-1.06,0L8,6.94,3.53,2.47a.75.75,0,0,0-1.06,0,.75.75,0,0,0,0,1.06L6.94,8,2.47,12.47a.75.75,0,1,0,1.06,1.06L8,9.06l4.47,4.47a.75.75,0,1,0,1.06-1.06Z"/>
      </g>
    </svg>
  );
};

const IconCloseMedium = (props: Props) => {
  const color = props.color || DEFAULT_COLOR;
  const className = colorClassNames.fill(color);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
      <g>
        <path className={className} d="M13.41,12l7.3-7.29a1,1,0,0,0,0-1.42,1,1,0,0,0-1.42,0L12,10.59,4.71,3.29a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.42L10.59,12l-7.3,7.29a1,1,0,0,0,1.42,1.42L12,13.41l7.29,7.3a1,1,0,0,0,1.42-1.42Z"/>
      </g>
    </svg>
  );
};

const IconCloseLarge = (props: Props) => {
  const color = props.color || DEFAULT_COLOR;
  const className = colorClassNames.fill(color);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="36px" height="36px">
      <g>
        <path className={className} d="M19.77,18,30.88,6.88a1.23,1.23,0,0,0,0-1.76,1.24,1.24,0,0,0-1.76,0L18,16.23,6.88,5.12a1.24,1.24,0,0,0-1.76,0,1.23,1.23,0,0,0,0,1.76L16.23,18,5.12,29.12a1.24,1.24,0,1,0,1.76,1.76L18,19.77,29.12,30.88a1.24,1.24,0,1,0,1.76-1.76Z"/>
      </g>
    </svg>
  );
};

const IconCloseXLarge = (props: Props) => {
  const color = props.color || DEFAULT_COLOR;
  const className = colorClassNames.fill(color);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56px" height="56px">
      <g>
        <path className={className} d="M30.12,28,47.06,11.06a1.5,1.5,0,0,0,0-2.12,1.49,1.49,0,0,0-2.12,0L28,25.88,11.06,8.94a1.49,1.49,0,0,0-2.12,0,1.5,1.5,0,0,0,0,2.12L25.88,28,8.94,44.94a1.5,1.5,0,1,0,2.12,2.12L28,30.12,44.94,47.06a1.5,1.5,0,1,0,2.12-2.12Z"/>
      </g>
    </svg>
  );
};

const IconClose = {
  Small: IconCloseSmall,
  Medium: IconCloseMedium,
  Large: IconCloseLarge,
  XLarge: IconCloseXLarge,
};

export default IconClose;
